import {TEST} from "./Set";

export function LOG(strings) {
    if (TEST) {
      return console.log(strings);
    }
}
